import * as yup from "yup";
// TODO change file name to schema
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const schemaEmail = yup.object({
  email: yup
    .string()
    .trim()
    .matches(emailRegex, "Please enter a valid email address")
    .required("Email is required"),
});

export const schemaOtpCode = yup.object({
  otpCode: yup.string().required("Please enter a valid otp code"),
});

export const schemaCreatePassword = yup.object({
  password: yup
    .string()
    .min(8, "Password must be at least 8 characters")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/\d/, "Password must contain at least one number")
    .matches(/[!@#$%^&*(),.?":{}|<>]/, "Password must contain at least one special character")
    .required("The password is incorrect. Please try another one"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "Passwords did not match. Please check again")
    .required("Confirm Password is required"),
});
